import React from 'react';
import { AiChatPanel } from '../../components/dashboard/Aichatpanel';

export function ChatPage() {
  return (
    <section className="flex h-full min-h-0 flex-1 flex-col">
      <AiChatPanel embedded />
    </section>
  );
}
